module.exports = __webpack_public_path__ + "static/img/guide2.f5a1a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide2.png
// module id = NVjv
// module chunks = 10